module.exports = {"noContact":"담당자 연락처가 없습니다.","sendFailed":"메시지 전송에 실패했습니다.","sendSuccess":"메시지가 전송되었습니다."}


//////////////////
// WEBPACK FOOTER
// ./src/locales/ko/sms.json
// module id = 8VUd
// module chunks = 2